import { LOCALES } from 'i18n/locales';

export const optInIntl = {
    [LOCALES.ENGLISH]: {
        'optIn.betaFeature': 'Beta feature'
    },
    [LOCALES.WELSH]: {
        'optIn.betaFeature': '[Beta feature]'
    }
};
